import React, { useState, useContext, memo } from 'react';
import './accountShow.scss';
import { AuthContext } from '../../context/auth-context';
import { connect } from 'react-redux';
import useHttpClient from '../../hooks/useHttpClient';
import Button from '../FormElements/Button';
import { MoonLoader } from 'react-spinners';
import { useHistory } from 'react-router-dom';
import { setAlert } from '../../../redux/alert/alert-actions';
import { closeSearchResult } from '../../../redux/search/search-actions';
import { mainAvatar } from '../../utils/onImageError';


const AccountShow = ({ account, userIdParam, followingList,
  openSearchResult, closeSearchResult }) => { 

  const { error, sendRequest, isLoading } = useHttpClient();

  const history = useHistory();

  const auth = useContext(AuthContext);

  const [isFollowing, setIsFollowing] = useState(true);

  const {_id, firstName, lastName, avatar} = account;

  const makeFollow = async () => {  

    try {
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/user/follow/${_id}`, 
      'PATCH', null, { Authorization: 'Bearer ' + auth.token });
      setIsFollowing(true);
      
    } catch (err) {return}
    
  };

  const makeUnfollow = async () => { 

    try {
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/user/unfollow/${_id}`, 
      'PATCH', null, { Authorization: 'Bearer ' + auth.token }); 
      
      setIsFollowing(false); 
      
    } catch (err) {return}
    
  }; 

  const pushTo = (_id) => {
    history.push(`/p/${_id}`)
  }

  error && setAlert(error, 'Error');

  return ( 
    <div className='account-show'> 
      <div className='account-show__left'> 
        <img className='account-img' src={avatar} alt='' 
        onError={(e)=>{e.target.onerror = null; e.target.src = mainAvatar}}
        onClick={() => {
          pushTo(_id);
          openSearchResult && closeSearchResult();
        }} /> 
        <h4 className='account-name'
        onClick={() => {
          pushTo(_id);
          openSearchResult && closeSearchResult();
        }} > {firstName.charAt(0).toUpperCase() + firstName.slice(1)} {lastName.charAt(0).toUpperCase() + lastName.slice(1)} </h4>
      </div>
      <div className='account-show__right'>
        {userIdParam === auth.user._id && !isFollowing && followingList &&
          <Button className='button but__flex button__follow' 
          style={{width: '40px', padding: '0px'}}
          onClick={() => makeFollow()} 
          disabled={isLoading} >
            {isLoading ? 
            (<MoonLoader color={'black'} loading={isLoading} size={15}/>) :
            (<i className='plus icon'></i>)}
          </Button>}
        {userIdParam === auth.user._id && isFollowing && followingList &&
          <Button className='button but__flex button__un-follow'
          style={{width: '40px', padding: '0px'}}
          onClick={() => makeUnfollow()} disabled={isLoading} >
            {isLoading ?
            (<MoonLoader color={'black'} loading={isLoading} size={15}/>) : 
            (<i className='check icon blue'></i>)}
          </Button>}
      </div>
    </div>
  )
}


const mapStateToProps = state => ({
  userIdParam: state.profile.userIdParam,
  openSearchResult: state.search.openSearchResult
})

export default connect(mapStateToProps, { closeSearchResult })(memo(AccountShow));